import { render, staticRenderFns } from "./ConfigureStudies.vue?vue&type=template&id=de55337a&"
import script from "./ConfigureStudies.vue?vue&type=script&lang=js&"
export * from "./ConfigureStudies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports